import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
import { Component, Input, OnInit, Output, OnChanges , SimpleChanges, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DiscoveryChatQuestion, ChatConsultant, PossibleResponse } from '../model/discovery-chat.interface';
import { find, remove } from 'lodash';
import { SlideInOutAnimation } from '../../animations';
import { UtilsService } from '../../moov-common/services/utils/utils.service';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AutofocusDirective } from 'src/app/moov-common/directives/autofocus/autofocus.directive';

const defaults = {
    delayEnter: '200ms',
    delayLeave: '0ms',
    timingEnter: '2s',
    timingLeave: '2s'
};
@Component({
  selector: 'app-chat-current-question',
  templateUrl: './chat-current-question.component.html',
  styleUrls: ['./chat-current-question.component.scss'],
  animations: [
  trigger('fadeSlideInOut', [
	transition(':enter', [
		style({ opacity: 0, transform: 'translateY(10px)' }),
		animate('500ms', style({ opacity: 1, transform: 'translateY(0)' })),
	]),
	transition(':leave', [
		animate('500ms', style({ opacity: 0, transform: 'translateY(10px)' })),
	]),
]),
  ]
  //  animations: [
    // trigger('slideInOut', [
    //   transition(':enter', [
    //     style({transform: 'translateY(-100%)'}),
    //     animate('200ms ease-in', style({transform: 'translateY(0%)'}))
    //   ]),
      // transition(':leave', [
      //   animate('200ms ease-in', style({transform: 'translateY(-100%)'}))
      // ])
  //   ])
  // ]
  //  animations:[SlideInOutAnimation]
  //     animations: [
  //     trigger('slideInOutRTL', [
  //       state('out', style({ color: 1})),
  //       state('in', style({ opacity: 0 })),
  //       transition('* => *', animate('300ms ease-out',style({transform: 'translateY(-100%)'}))),
  //   ])
  // ]

  
})
export class ChatCurrentQuestionComponent
  extends BaseComponent
  implements OnInit {
  @Input() currentQuestion?: DiscoveryChatQuestion;
  @Input() consultant: ChatConsultant;
  @Input() isLoading: boolean = true;
  @Input() removeResponses: PossibleResponse[] = [];
  @Input() focusBottom: boolean = false;
  @Output() sendQuestionResponseEvent = new EventEmitter<DiscoveryChatQuestion>();
  userResponseNumber: number = 1;
  possibleResponses: PossibleResponse[] = [];
  @ViewChild('bottomChat') bottomChat: ElementRef;
  @ViewChild('topChat') topChat: ElementRef;
  
  imageRootFolder = "assets/common/";

    
constructor(public readonly utilsService: UtilsService) {
    super();
 }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentQuestion !== undefined) {
      // this.focusOnElementOnChat(this.topChat);
      this.userResponseNumber = this.currentQuestion.userResponsesNo;
      this.possibleResponses = this.currentQuestion.possibleResponses.filter(
        res => {
          return !this.removeResponses.find(remRev => {
            return (remRev.idx === res.idx)
          })
          // return !this.removeResponses.includes(res);
        }
      )
      // console.log(`this.possibleResponses are ${this.possibleResponses.map(({ idx }) => idx)}`);
    }
   
  }

responsesPopulatedEvent() {
  this.focusOnElementOnChat(this.bottomChat);
}

  sendQuestionResponse(responsesIds: string[]) {
    
    if (this.currentQuestion) {
      let currentQuestion = this.currentQuestion;

      let selectedResponses: PossibleResponse[] = this.currentQuestion.possibleResponses.filter(function(o: PossibleResponse) {
          return ((responsesIds.includes(o.id)) && (o.questionId === currentQuestion.id))
      })
      if (selectedResponses) {
          selectedResponses.forEach((element: PossibleResponse) => {
            element.selected = true;
          });
        this.sendQuestionResponseEvent.emit(this.currentQuestion);
      }
    }
  }

  focusOnElementOnChat(focusElement: any) {
    let focusDiv = focusElement.nativeElement;
    // console.log('scrolling to '+focusDiv.id);
    //  focusDiv.focus();
    // focusDiv.scrollIntoView({behavior: 'smooth', block: 'end' });
    focusDiv.scrollIntoView(false);
  //   let focusDivJ = (<any>$('#' + focusElement));
  //   console.log('scrolling to '+focusDivJ);
  //  let scrollHeight = Math.max(focusDivJ.scrollHeight, focusDivJ.clientHeight);
  //  focusDivJ.scrollTop = scrollHeight - focusDivJ.clientHeight;
  }

}
